export function isTeknikerContext(): boolean {
    if (typeof window === "undefined") {
        return false;
    }

    const pathname = window.location.pathname || "";
    const hash = window.location.hash || "";
    if (pathname.startsWith("/tekniker-login") || hash.startsWith("#/tekniker-login")) {
        return true;
    }

    const requestedMode = getRequestedMode();
    if (requestedMode === "tekniker") {
        return true;
    }
    if (requestedMode === "forbruger") {
        return false;
    }

    const hostname = (window.location.hostname || "").toLowerCase();
    const isTeknikerLocalhost =
        hostname === "teknik.localhost" ||
        hostname === "tekniker.localhost" ||
        hostname === "dev-teknik.localhost" ||
        hostname === "servicepro.localhost";
    const isTeknikerSubdomain =
        hostname &&
        hostname !== "localhost" &&
        !hostname.startsWith("127.") &&
        (hostname.startsWith("teknik.") ||
            hostname.startsWith("tekniker.") ||
            hostname.startsWith("dev-teknik.") ||
            hostname.startsWith("servicepro.") ||
            hostname.startsWith("dev-servicepro.") ||
            hostname.startsWith("dev-servicepro-"));

    return isTeknikerLocalhost || isTeknikerSubdomain || hasTeknikerQueryParam();
}

export function hasTeknikerQueryParam(): boolean {
    if (typeof window === "undefined") {
        return false;
    }

    const search = getSearchFromLocation();
    if (!search) {
        return false;
    }

    return getRequestedMode() === "tekniker";
}

function getRequestedMode(): "tekniker" | "forbruger" | null {
    const search = getSearchFromLocation();
    if (!search) {
        return null;
    }

    const params = new URLSearchParams(search);
    const teknikerParam = params.get("tekniker");
    if (teknikerParam !== null) {
        if (teknikerParam === "" || teknikerParam === "1" || teknikerParam.toLowerCase() === "true") {
            return "tekniker";
        }
        if (teknikerParam === "0" || teknikerParam.toLowerCase() === "false") {
            return "forbruger";
        }
    }

    const appParam = params.get("app") || params.get("mode") || params.get("role");
    if (!appParam) {
        return null;
    }

    const normalized = appParam.toLowerCase();
    if (normalized === "tekniker") {
        return "tekniker";
    }
    if (normalized === "forbruger" || normalized === "consumer") {
        return "forbruger";
    }

    return null;
}

function getSearchFromLocation(): string {
    if (typeof window === "undefined") {
        return "";
    }

    const search = window.location.search || "";
    if (search) {
        return search;
    }

    const hash = window.location.hash || "";
    const queryIndex = hash.indexOf("?");
    return queryIndex >= 0 ? hash.slice(queryIndex) : "";
}
